export default __webpack_public_path__ + "static/media/sygnetInRoundedRect.efd5a315.svg";